export const ORGA_ROLES = Object.freeze({
  ORG_ADMIN: 1,
  MANAGER: 2,
  USER: 3,
  EXPLORER_VIEWER: 4,
  EXPLORER_ADMIN: 5,
  DASHBOARD_VIEWER: 6,
});

